import React from 'react';
import { useDebounce } from 'use-debounce';

export const useDebouncedStringCallback = ({ startVal, debounceCallback, debounceTime = 1000 }) => {
    const [value, setValue] = React.useState(startVal);
    const [debouncedVal] = useDebounce(value, debounceTime);

    React.useEffect(() => {
        setValue(startVal);
    }, [startVal, setValue]);

    React.useEffect(() => {
        if (debouncedVal !== startVal) {
            debounceCallback(debouncedVal);
        }
    }, [debouncedVal]);

    return [value, setValue];
};
